export default __webpack_public_path__ + "static/media/evenshot.a183820e.jpg";